import mixpanel from "mixpanel-browser";

console.log();
const MIXPANEL_TOKEN =
  process.env.REACT_APP_MIXPANEL_TOKEN ?? "29033d5c7446c7d60657f6e4ada2e900";

mixpanel.init(MIXPANEL_TOKEN, {
  debug: false,
  track_pageview: false,
  persistence: "localStorage",
});

export const mixpanelIdentifyUser = (userId: string) => {
  mixpanel.identify(userId);
};

export const mixpanelSetUserInfo = (key: string, value: string) => {
  mixpanel.people.set({ key, value });
};

export const mixpanelTrack = (
  evenName: string,
  propertyNameAdnPropertyValues: {
    propertyName: string;
    propertyValue: string;
  }[] = [],
) => {
  mixpanel.track(evenName, {
    ...Object.fromEntries(
      propertyNameAdnPropertyValues.map(({ propertyName, propertyValue }) => [
        propertyName,
        propertyValue,
      ]),
    ),
  });
};
